'use strict';

var cart = require('../cart/cart');

var updateMiniCart = true;
var $minicart = $('.minicart');
var $minicartLink = $minicart.find('.minicart-link');
var $popover = $minicart.find('.popover');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessageAndRemoveFromCart(data) {
	$.spinner().stop();
	var status = data.success ? 'alert-success' : 'alert-danger';

	if ($('.add-to-wishlist-messages').length === 0) {
		$('body').append('<div class="add-to-wishlist-messages "></div>');
	}
	$('.add-to-wishlist-messages')
		.append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

	setTimeout(function () {
		$('.add-to-wishlist-messages').remove();
	}, 1500);
	var $targetElement = $('a[data-pid="' + data.pid + '"]').closest('.product-info').find('.remove-product');
	var itemToMove = {
		actionUrl: $targetElement.data('action'),
		productID: $targetElement.data('pid'),
		productName: $targetElement.data('name'),
		uuid: $targetElement.data('uuid')
	};
	$('body').trigger('afterRemoveFromCart', itemToMove);
	setTimeout(function () {
		$('.cart.cart-page #removeProductModal').modal();
	}, 1000);
}
/**
 * move items from Cart to wishlist
 * returns json object with success or error message
 */
function moveToWishlist() {
	$('body').on('click', '.product-move .move', function (e) {
		e.preventDefault();
		var url = $(this).attr('href');
		var pid = $(this).data('pid');
		var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
		var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
		optionId = optionId || null;
		optionVal = optionVal || null;
		if (!url || !pid) {
			return;
		}

		$.spinner().start();
		$.ajax({
			url: url,
			type: 'post',
			dataType: 'json',
			data: {
				pid: pid,
				optionId: optionId,
				optionVal: optionVal
			},
			success: function (data) {
				displayMessageAndRemoveFromCart(data);
			},
			error: function (err) {
				displayMessageAndRemoveFromCart(err);
			}
		});
	});
}

/**
* Closes the mini cart popover by removing the 'show' class and updating the aria attribute.
* This function is responsible for hiding the popover element and ensuring accessibility compliance
* by setting the 'aria-expanded' attribute to 'false'.
*/
function closePopup() {
    $popover.removeClass('show');
    $minicart.attr('aria-expanded', 'false');
}

/**
* Opens the popover for the mini cart, making it visible to the user.
* This function adds the 'show' class to the popover element and sets
* the 'aria-expanded' attribute of the mini cart to 'true', indicating
* that the popover is currently expanded.
*/
function openPopup() {
    $popover.addClass('show');
    $minicart.attr('aria-expanded', 'true');
}

module.exports = function () {
	cart();
	moveToWishlist();

    $minicart.on('count:update', function (event, count) {
		if (count && $.isNumeric(count.quantityTotal)) {
			$('.minicart .minicart-quantity').text(count.quantityTotal);
			$('.minicart .minicart-link').attr({
				'aria-label': count.minicartCountOfItems,
				title: count.minicartCountOfItems
			});
		}
	});

    $minicart.on('mouseenter focusin touchstart', function (event) {
		if ($('.search:visible').length === 0) {
			return;
		}

        var url = $minicart.data('action-url');
		var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && !$popover.hasClass('show') && !$(event.relatedTarget).hasClass('js-minicart-link')) {
			if (!updateMiniCart) {
                openPopup();
				return;
			}

            openPopup();
            $popover.spinner().start();

			$.get(url, function (data) {
                $popover.empty();
                $popover.append(data);
				updateMiniCart = false;
				$.spinner().stop();
			});
		}
	});

    $('body').on('touchstart click', function (e) {
        if ($minicart.has(e.target).length === 0) {
            closePopup();
        }
    });

    $minicart.on('mouseleave', function (event) {
        if ((event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
			|| $('body').hasClass('modal-open')) {
			event.stopPropagation();
			return;
		}

        closePopup();
	});

    $minicartLink.on('focusout', function (event) {
        if (!$(event.relatedTarget).hasClass('js-minicart-link')) {
            closePopup();
        }
    });

    $popover.on('focusout', 'a, button, input, select', function (event) {
        if ($(event.relatedTarget).hasClass('minicart-link') || $(event.relatedTarget).hasClass('location-icon-link')) {
            closePopup();
        }
    });

	$('body').on('change', '.minicart .quantity', function () {
		if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
			// eslint-disable-next-line no-restricted-globals
			location.reload();
		}
	});
	$('body').on('product:afterAddToCart', function () {
		updateMiniCart = true;
	});
	$('body').on('cart:update', function () {
		updateMiniCart = true;
	});
};
